import React, { Component } from "react";
import PropTypes from "prop-types";
import YesNoModal from "../../../../shared/components/modals/YesNoModal";
import Navigate from "../../../../shared/navigation/navigate";
import { routesContext } from "../../../../shared/routes/routes-context";

class NoActiveTeesModal extends Component {
  static contextType = routesContext;
  onClose = () => {
    const { onClose } = this.props;
    onClose();
    Navigate.goBack();
  };

  onConfirm = () => {
    this.context.manuallyHandicapCalculator.navigate();
  };

  render() {
    const { isOpen } = this.props;
    return (
      <YesNoModal
        onConfirm={this.onConfirm}
        onAbort={this.onClose}
        isNoVisible={false}
        isOpen={isOpen}
        yesTitle="Manually Calculate Course Handicap"
      >
        <p>This Course does not have any active or rated tees.</p>
      </YesNoModal>
    );
  }
}

NoActiveTeesModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default NoActiveTeesModal;
